import { AnyAction } from 'redux'
import { Observable, EMPTY, of } from 'rxjs'
import { ACTION_LOAD_INVOICE_UPDATE_PROGRESS, actionLoadInvoiceUpdateProgressSuccess } from './billing-job-actions'
import { flatMap, map, withLatestFrom, mergeMap, concatMap, filter } from 'rxjs/operators'
import { combineEpics, ofType } from 'redux-observable'
import { defaultCatchError } from '../app/app-epics'
import BillingJobClient from 'clients/billing-job-client'

export const loadInvoiceUpdateProgress = (action$: Observable<AnyAction>, state$: Observable<any>) => {
    return action$.pipe(
        ofType(ACTION_LOAD_INVOICE_UPDATE_PROGRESS),
        withLatestFrom(state$),
        flatMap(
            ([action, state]): Observable<AnyAction> =>
                BillingJobClient.getUpdateProgress().pipe(
                    map((result) => actionLoadInvoiceUpdateProgressSuccess(result)),
                    defaultCatchError(),
                ),
        ),
    )
}

export const billingJobEpics = combineEpics(loadInvoiceUpdateProgress)
